/* 🤖 this file was generated by svg-to-ts */
export const matIconStraight: {
  name: 'straight';
  data: string;
} = {
  name: 'straight',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M11 6.83 9.41 8.41 8 7l4-4 4 4-1.41 1.41L13 6.83V21h-2z"/></svg>`
};
